var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 7.33325C18.9355 7.33325 20.1667 6.10204 20.1667 4.58325C20.1667 3.06447 18.9355 1.83325 17.4167 1.83325C15.8979 1.83325 14.6667 3.06447 14.6667 4.58325C14.6667 6.10204 15.8979 7.33325 17.4167 7.33325Z",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 11.9167H11",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 15.5833H14.6667",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 1.83325H8.25C3.66667 1.83325 1.83333 3.66659 1.83333 8.24992V13.7499C1.83333 18.3333 3.66667 20.1666 8.25 20.1666H13.75C18.3333 20.1666 20.1667 18.3333 20.1667 13.7499V9.16658",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsIcon);
export default __webpack_public_path__ + "static/media/transactions-icon.885fe10c8e3b8873e96b76b494d3dbfc.svg";
export { ForwardRef as ReactComponent };